import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, TextField } from '@mui/material';

// interface PasswordResetFormProps {
//   onSubmit?: (email: string) => void | Promise<void>;
//   sx?: object;
// }

interface PasswordResetFormProps {
  onSubmit?: (email: string) => unknown;  // принимает любой возврат
  sx?: object;
}

const PasswordResetForm: React.FC<PasswordResetFormProps> = ({ onSubmit, sx }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setError('Please enter your email address.');
      return;
    }

    setStatus('sending');

    try {
      if (onSubmit) {
        await Promise.resolve(onSubmit(trimmedEmail));
      } else {
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
      setStatus('sent');
    } catch {
      setError('Unable to send password reset link. Please try again.');
      setStatus('error');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: 2, ...sx }}>
      <TextField
        id="password-reset-email"
        type="email"
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        autoComplete="email"
        disabled={status === 'sending'}
        size="small"
        fullWidth
      />
      {error && <Alert severity="error">{error}</Alert>}
      {status === 'sent' && !error && (
        <Alert severity="success">Password reset link sent. Check your email.</Alert>
      )}
      <Button
        type="submit"
        variant="contained"
        disabled={status === 'sending'}
        startIcon={status === 'sending' ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        {status === 'sending' ? 'Sending...' : 'Send reset link'}
      </Button>
    </Box>
  );
};

export default PasswordResetForm;